import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import LoadingModal from "../../../components/loadingModal"
import { ApiEndpoints, reqGetNew, reqPostNew } from "../../../config/apiClient"
import DespesasGraficoTabela from "./componentes/DespesasGraficoTable"
import DespesasMetricasDatas from "./componentes/DespesasMetricasDatas"
import DespesasMetricasFiltroOptions from "./componentes/DespesasMetricasFiltros"
import DespesasTotais from "./componentes/DespesasTotais"
import MetricasGraficoBarraDias from "./componentes/DespesasGraficoDias"
import DespesasGraficoBarStatusRelatorios, { handleRelatoriosSelecionados } from "./componentes/DespesasGraficoBarStatusRelatorios"
import DespesasTabelaPesquisa from "./componentes/DespesasTabelaPesquisa"

export default function DespesasMetricasPage() {
    const [notas, setNotas] = useState<any[]>([])
    const [relatorios, setRelatorios] = useState<any[]>([])
    const [despesas, setDespesas] = useState<any[]>([])
    const [despesasSel, setDespesasSel] = useState<any[]>([])
    const [despesasTotal, setDespesasTotal] = useState<iTotalDespesas>({ qtd: 0, qtd_relatorios: 0, valor: "0.00", valor_interno: "0.00", valor_interno_por: "0.00", valor_interno_qtd: 0, valor_contratos: "0.00", valor_contratos_por: "0.00", valor_contratos_qtd: 0, nf_qtd: 0, nf_valor: "0.00", nf_valor_liquido: "0.00", lucro_bruto: "0.00" })
    const [loading, setLoading] = useState<boolean>(false)
    const [metricasFiltroDados, setMetricasFiltroDados] = useState<any>({})
    const [metricasFiltro, setMetricasFiltro] = useState<iMetricasFiltro>({ empresas: [], usuarios: [], categorias: [], clientes: [], formasPagamento: [], cartoes: [] })
    const [metricasFiltroOrdem, setMetricasFiltroOrdem] = useState<string[]>([])

    const [dataInicialTemp, setDataInicialTemp] = useState<string>(dayjs().startOf('month').format("YYYY-MM-DD"))
    const [dataFinalTemp, setDataFinalTemp] = useState<string>(dayjs().endOf('month').format("YYYY-MM-DD"))
    const [dataInicial, setDataInicial] = useState<string>(dayjs().startOf('month').format("YYYY-MM-DD"))
    const [dataFinal, setDataFinal] = useState<string>(dayjs().endOf('month').format("YYYY-MM-DD"))
    const [datasSelecionadas, setDatasSelecionadas] = useState<string[]>([])
    const [statusSelecionados, setStatusSelecionados] = useState<string[]>([])

    const [filtroSel, setFiltroSel] = useState<iMetricasFiltro>({ empresas: [], usuarios: [], categorias: [], clientes: [], formasPagamento: [], cartoes: [] })
    const [filtroEmpresas, setFiltroEmpresas] = useState<any[]>([])
    const [filtroUsuarios, setFiltroUsuarios] = useState<any[]>([])
    const [filtroCategorias, setFiltroCategorias] = useState<any[]>([])
    const [filtroClientes, setFiltroClientes] = useState<any[]>([])
    const [filtroFormasPagamento, setFiltroFormasPagamento] = useState<any[]>([])
    const [filtroCartoes, setFiltroCartoes] = useState<any[]>([])

    useEffect(() => {
        document.title = `Despesas Métricas | OB PORTUS`
        handlePageLoading()
        // eslint-disable-next-line
    }, [])
    async function handlePageLoading() {
        setLoading(true)
        await loadFiltro()
        const metricas_dados = await getDespesas()
        setDespesasSel(metricas_dados.despesas)
        handleCalcTotal(metricas_dados.relatorios, metricas_dados.despesas, metricas_dados.notas)
        setLoading(false)
    }
    async function loadFiltro(): Promise<void> {
        const api = await reqGetNew(ApiEndpoints.despesasMetricasFiltro)
        if (api.status !== 200) {
            return
        }
        setMetricasFiltroDados(api.data)
        const filtrosAux = loadFiltroAux(api.data)
        setMetricasFiltro(filtrosAux)
    }
    function loadFiltroAux(dados: any): iMetricasFiltro {
        let empresasAux: any[] = []
        for (let empresa of dados.empresas) {
            empresasAux.push({
                value: empresa.id_empresa,
                label: `${empresa.nome}`,
            })
        }
        let usuariosAux: any[] = []
        for (let user of dados.usuarios) {
            if (user.id_colaborador === null) {
                continue
            }
            usuariosAux.push({
                value: user.id_colaborador,
                label: `${user.nome}`,
            })
        }
        let categoriasAux: any[] = []
        for (let cat of dados.categorias) {
            categoriasAux.push({
                value: cat.id_categoria,
                label: `${cat.descricao}`,
            })
        }
        let clientesAux: any[] = []
        for (let cliente of dados.clientes) {
            clientesAux.push({
                value: cliente.id_cliente,
                label: `${cliente.descricao}`,
            })
        }
        let formasPagamentoAux: any[] = []
        for (let forma of dados.formasPagamento) {
            formasPagamentoAux.push({
                value: forma.id_forma_pagamento,
                label: `${forma.codigo} ${forma.descricao}`,
            })
        }
        let cartoesAux: any[] = []
        for (let cartao of dados.cartoes) {
            const num_cartao = String(cartao.num_cartao)
            cartoesAux.push({
                value: cartao.id_cartao,
                label: `${cartao.id_empresa.nome} ${cartao.nome_portador} ${num_cartao.substring(num_cartao.length - 4)}`,
            })
        }
        const filtrosAux: iMetricasFiltro = {
            empresas: empresasAux,
            usuarios: usuariosAux,
            categorias: categoriasAux,
            clientes: clientesAux,
            formasPagamento: formasPagamentoAux,
            cartoes: cartoesAux,
        }
        return filtrosAux
    }
    async function getDespesas(): Promise<iMetricasDadosResponse> {
        const dados = {
            data_inicial: dataInicialTemp,
            data_final: dataFinalTemp,
            id_usuarios: [],
            id_categorias: [],
            id_clientes: [],
            id_formas_pagamento: [],
            id_cartoes: [],
        }
        setDataInicial(dataInicialTemp)
        setDataFinal(dataFinalTemp)
        const api = await reqPostNew(ApiEndpoints.despesasMetricasDados, dados)
        if (api.status !== 200) {
            return { despesas: [], relatorios: [], notas: [], }
        }
        const metricas_dados: iMetricasDadosResponse = api.data
        setDespesas(metricas_dados.despesas)
        setRelatorios(metricas_dados.relatorios)
        setNotas(metricas_dados.notas)
        return metricas_dados
    }
    async function loadDespesas() {
        setLoading(true)
        const metricas_dados = await getDespesas()
        handleAplicarFiltro(metricasFiltroOrdem, filtroSel, metricas_dados.relatorios, metricas_dados.despesas, metricas_dados.notas)
        setDatasSelecionadas([])
        setStatusSelecionados([])
        setLoading(false)
    }

    function handleChangeFiltro(choice: any[], filtroNome: string) {
        let filtroSelAux: iMetricasFiltro = filtroSel
        switch (filtroNome) {
            case 'id_empresas':
                setFiltroEmpresas(choice)
                filtroSelAux.empresas = choice.map((reg, idx, arr) => { return Number(reg.value) })
                break
            case 'id_usuarios':
                setFiltroUsuarios(choice)
                filtroSelAux.usuarios = choice.map((reg, idx, arr) => { return Number(reg.value) })
                break
            case 'id_categorias':
                setFiltroCategorias(choice)
                filtroSelAux.categorias = choice.map((reg, idx, arr) => { return Number(reg.value) })
                break
            case 'id_clientes':
                setFiltroClientes(choice)
                filtroSelAux.clientes = choice.map((reg, idx, arr) => { return Number(reg.value) })
                break
            case 'id_formasPagamento':
                setFiltroFormasPagamento(choice)
                filtroSelAux.formasPagamento = choice.map((reg, idx, arr) => { return Number(reg.value) })
                break
            case 'id_cartoes':
                setFiltroCartoes(choice)
                filtroSelAux.cartoes = choice.map((reg, idx, arr) => { return Number(reg.value) })
                break
            default:
                return
        }
        setFiltroSel(filtroSelAux)

        const adicionar = choice.length === 0 ? true : false
        let ordem = handleFiltroOrdem(filtroNome, adicionar)

        setDatasSelecionadas([])
        setStatusSelecionados([])
        handleAplicarFiltro(ordem, filtroSelAux, relatorios, despesas, notas)
    }
    function handleAplicarFiltro(ordem: string[], filtroSelAux: iMetricasFiltro, relatorios: any[], despesas: any[], notas: any[]) {
        if (ordem.length === 0) {
            setDespesasSel(despesas)
            handleCalcTotal(relatorios, despesas, notas)
            if (metricasFiltro.empresas.length > 0) {
                const filtrosAux = loadFiltroAux(metricasFiltroDados)
                setMetricasFiltro(filtrosAux)
            }
            return despesas
        }

        let despesasSel: any = despesas
        let notasSel: any = notas
        const ultimoFiltroNome = ordem.length > 1 ? ordem[ordem.length - 1] : ordem[0];
        for (let filtroNome of ordem) {
            despesasSel = handleDadosFiltrados(filtroSelAux, despesasSel, filtroNome)
            notasSel = handleDadosFiltradosNotas(filtroSelAux, notasSel, filtroNome)
        }
        setDespesasSel(despesasSel)
        handleCalcTotal(relatorios, despesasSel, notasSel)
        handleUpdateFiltrosOptions(filtroSelAux, despesasSel, ultimoFiltroNome)
        return despesasSel
    }
    function handleFiltroOrdem(filtroNome: string, adicionar: boolean): string[] {
        let ordem: string[] = metricasFiltroOrdem
        let existeFiltro = ordem.filter(reg => reg === filtroNome).length === 0 ? false : true

        if (existeFiltro === false) {
            if (adicionar === true) {
                return ordem
            }
            if (adicionar === false) {
                if (filtroNome === "id_empresas") {
                    ordem.unshift(filtroNome)
                } else {
                    ordem.push(filtroNome)
                }
                setMetricasFiltroOrdem(ordem)
                return ordem
            }
        }
        if (existeFiltro) {
            if (adicionar === false) {
                return ordem
            }
            if (adicionar === true) {
                ordem = ordem.filter(reg => reg !== filtroNome)
                setMetricasFiltroOrdem(ordem)
                return ordem
            }
        }
        return ordem
    }
    function handleDadosFiltrados(filtro: iMetricasFiltro, despesas: any[], filtroNome: string) {
        let dadosAux: any[] = []
        if (filtro.empresas.length > 0 && filtroNome === "id_empresas") {
            let sel = despesas.filter(reg => filtro.empresas.includes(reg.id_empresa.id_empresa))
            dadosAux = handleChangeDadosFiltrados(dadosAux, sel)
        }
        if (filtro.usuarios.length > 0 && filtroNome === "id_usuarios") {
            let sel = despesas.filter(reg => filtro.usuarios.includes(reg.id_relatorio.id_colaborador))
            dadosAux = handleChangeDadosFiltrados(dadosAux, sel)
        }
        if (filtro.categorias.length > 0 && filtroNome === "id_categorias") {
            let sel = despesas.filter(reg => filtro.categorias.includes(reg.id_categoria.id_categoria))
            dadosAux = handleChangeDadosFiltrados(dadosAux, sel)
        }
        if (filtro.clientes.length > 0 && filtroNome === "id_clientes") {
            let sel = despesas.filter(reg => filtro.clientes.includes(reg.id_cliente.id_cliente))
            dadosAux = handleChangeDadosFiltrados(dadosAux, sel)
        }
        if (filtro.formasPagamento.length > 0 && filtroNome === "id_formasPagamento") {
            let sel = despesas.filter(reg => filtro.formasPagamento.includes(reg.id_forma_pagamento.id_forma_pagamento))
            dadosAux = handleChangeDadosFiltrados(dadosAux, sel)
        }
        if (filtro.cartoes.length > 0 && filtroNome === "id_cartoes") {
            const cartoes = despesas.filter(reg => reg.id_cartao !== null)
            let sel = cartoes.filter(reg => filtro.cartoes.includes(reg.id_cartao.id_cartao))
            dadosAux = handleChangeDadosFiltrados(dadosAux, sel)
        }
        return dadosAux
    }
    function handleDadosFiltradosNotas(filtro: iMetricasFiltro, notas: any[], filtroNome: string) {
        let dadosAux: any[] = notas
        if (filtro.empresas.length > 0 && filtroNome === "id_empresas") {
            dadosAux = dadosAux.filter(reg => filtro.empresas.includes(reg.id_empresa.id_empresa))
        }
        return dadosAux
    }
    function handleChangeDadosFiltrados(atual: any[], novos: any[]) {
        for (let novo of novos) {
            let encontrado = false
            for (let reg of atual) {
                if (reg.id_despesa === novo.id_despesa) {
                    encontrado = true
                    break
                }
            }
            if (encontrado) { continue }
            atual.push(novo)
        }
        return atual
    }
    function handleUpdateFiltrosOptions(filtro: iMetricasFiltro, despesas: any[], ultimoFiltroNome: string) {
        let usuariosAux: any[] = []
        for (let user of metricasFiltroDados.usuarios) {
            if (user.id_colaborador === null) {
                continue
            }
            const id_colaborador = user.id_colaborador
            const existe = despesas.filter(reg => reg.id_relatorio.id_colaborador === id_colaborador).length === 0 ? false : true
            if (existe) {
                usuariosAux.push({
                    value: user.id_colaborador,
                    label: `${user.nome}`,
                })
            }
        }
        if (ultimoFiltroNome !== "id_usuarios") {
            metricasFiltro['usuarios'] = usuariosAux
        }

        let categoriasAux: any[] = []
        for (let cat of metricasFiltroDados.categorias) {
            const id_categoria = cat.id_categoria
            const existe = despesas.filter(reg => reg.id_categoria.id_categoria === id_categoria).length === 0 ? false : true
            if (existe) {
                categoriasAux.push({
                    value: cat.id_categoria,
                    label: `${cat.descricao}`,
                })
            }
        }
        if (ultimoFiltroNome !== "id_categorias") {
            metricasFiltro['categorias'] = categoriasAux
        }

        let clientesAux: any[] = []
        for (let cliente of metricasFiltroDados.clientes) {
            const id_cliente = cliente.id_cliente
            const existe = despesas.filter(reg => reg.id_cliente.id_cliente === id_cliente).length === 0 ? false : true
            if (existe) {
                clientesAux.push({
                    value: cliente.id_cliente,
                    label: `${cliente.descricao}`,
                })
            }
        }
        if (ultimoFiltroNome !== "id_clientes") {
            metricasFiltro['clientes'] = clientesAux
        }

        let formasPagamentoAux: any[] = []
        for (let forma of metricasFiltroDados.formasPagamento) {
            const id_forma_pagamento = forma.id_forma_pagamento
            const existe = despesas.filter(reg => reg.id_forma_pagamento.id_forma_pagamento === id_forma_pagamento).length === 0 ? false : true
            if (existe) {
                formasPagamentoAux.push({
                    value: forma.id_forma_pagamento,
                    label: `${forma.codigo} ${forma.descricao}`,
                })
            }
        }
        if (ultimoFiltroNome !== "id_formasPagamento") {
            metricasFiltro['formasPagamento'] = formasPagamentoAux
        }

        let cartoesAux: any[] = []
        for (let cartao of metricasFiltroDados.cartoes) {
            const id_cartao = cartao.id_cartao
            const num_cartao = String(cartao.num_cartao)
            const cartoes: any[] = despesas.filter(reg => reg.id_cartao !== null)
            const existe = cartoes.filter(reg => reg.id_cartao.id_cartao === id_cartao).length === 0 ? false : true
            if (existe) {
                cartoesAux.push({
                    value: cartao.id_cartao,
                    label: `${cartao.id_empresa.nome} ${cartao.nome_portador} ${num_cartao.substring(num_cartao.length - 4)}`,
                })
            }
        }
        if (ultimoFiltroNome !== "id_cartoes") {
            metricasFiltro['cartoes'] = cartoesAux
        }

        setMetricasFiltro(metricasFiltro)
    }
    function handleCalcTotal(relatorios: any[], registros: any[], nfs: any[]) {
        let registrosTotais: iTotalDespesas = {
            qtd: 0,
            qtd_relatorios: 0,
            valor: "0.00",
            valor_interno: "0.00",
            valor_interno_por: "0.00",
            valor_interno_qtd: 0,
            valor_contratos: "0.00",
            valor_contratos_por: "0.00",
            valor_contratos_qtd: 0,
            nf_qtd: 0,
            nf_valor: "0.00",
            nf_valor_liquido: "0.00",
            lucro_bruto: "0.00",
        }
        for (let idx in registros) {
            let despesa = registros[idx]
            let valor_despesa = despesa.valor
            registrosTotais.qtd += 1
            registrosTotais.valor = Number(Number(registrosTotais.valor) + Number(valor_despesa)).toFixed(2)
            const ids_clientes_interno = [1, 29, 30, 34]
            const despesa_interna = ids_clientes_interno.includes(despesa.id_cliente.id_cliente)
            if (despesa_interna) {
                registrosTotais.valor_interno = Number(Number(registrosTotais.valor_interno) + Number(valor_despesa)).toFixed(2)
                registrosTotais.valor_interno_qtd += 1
                const porcentagem = ((registrosTotais.valor_interno_qtd * 100) / registros.length).toFixed(2)
                registrosTotais.valor_interno_por = porcentagem
            }
            if (!despesa_interna) {
                registrosTotais.valor_contratos = Number(Number(registrosTotais.valor_contratos) + Number(valor_despesa)).toFixed(2)
                registrosTotais.valor_contratos_qtd += 1
                const porcentagem = ((registrosTotais.valor_contratos_qtd * 100) / registros.length).toFixed(2)
                registrosTotais.valor_contratos_por = porcentagem
            }
        }
        const moneyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
        for (let idx in nfs) {
            let nota = nfs[idx]
            let valor_nota = nota.valor_servicos
            let valor_nota_liquido = nota.valor_liquido
            registrosTotais.nf_qtd += 1
            registrosTotais.nf_valor = Number(Number(registrosTotais.nf_valor) + Number(valor_nota)).toFixed(2)
            registrosTotais.nf_valor_liquido = Number(Number(registrosTotais.nf_valor_liquido) + Number(valor_nota_liquido)).toFixed(2)
        }
        const lucro_bruto = Number(Number(registrosTotais.nf_valor_liquido) - Number(registrosTotais.valor)).toFixed(2)
        registrosTotais.lucro_bruto = moneyFormatter.format(Number(lucro_bruto))

        registrosTotais.nf_valor = moneyFormatter.format(Number(registrosTotais.nf_valor))
        registrosTotais.nf_valor_liquido = moneyFormatter.format(Number(registrosTotais.nf_valor_liquido))
         registrosTotais.valor = moneyFormatter.format(Number(registrosTotais.valor))
        registrosTotais.valor_interno = moneyFormatter.format(Number(registrosTotais.valor_interno))
        registrosTotais.valor_contratos = moneyFormatter.format(Number(registrosTotais.valor_contratos))
        const relatoriosAux = handleRelatoriosSelecionados(relatorios, registros)
        registrosTotais.qtd_relatorios = relatoriosAux.length
        
        setDespesasTotal(registrosTotais)
    }

    async function handleChangeDate(dados: any) {
        if (dados.id === "data_inicial") {
            setDataInicialTemp(dados.value)
        }
        if (dados.id === "data_final") {
            setDataFinalTemp(dados.value)
        }
    }
    async function handleArrow(comando: "futuro" | "passado") {
        if (comando === "futuro") {
            const dataInicialAux = dayjs(dataInicialTemp).startOf('month').endOf('month').add(1, 'day')
            const dataFinalAux = dataInicialAux.endOf('month')
            setDataInicialTemp(dataInicialAux.format("YYYY-MM-DD"))
            setDataFinalTemp(dataFinalAux.format("YYYY-MM-DD"))
        }
        if (comando === "passado") {
            const dataInicialAux = dayjs(dataInicialTemp).startOf('month').subtract(1, 'day').startOf('month')
            const dataFinalAux = dataInicialAux.endOf('month')
            setDataInicialTemp(dataInicialAux.format("YYYY-MM-DD"))
            setDataFinalTemp(dataFinalAux.format("YYYY-MM-DD"))
        }

    }
    function handleDiaSelecionado(event: any) {
        const data_dia: string = event.data_dia
        let dias_selecionados = datasSelecionadas
        const existe = dias_selecionados.filter((reg) => reg === data_dia).length === 0 ? false : true
        if (existe) {
            dias_selecionados = dias_selecionados.filter((reg) => reg !== data_dia)
        } else {
            if (data_dia.length === 2) {
                dias_selecionados.push(data_dia)
            }
        }
        setDatasSelecionadas(dias_selecionados)
        if (dias_selecionados.length === 0) {
            handleAplicarFiltro(metricasFiltroOrdem, filtroSel, relatorios, despesas, notas)
            return
        }
        let despesasSelAux: any = handleAplicarFiltro(metricasFiltroOrdem, filtroSel, relatorios, despesas, notas)
        let sel = despesasSelAux.filter((reg: any) => {
            let data_despesa = dayjs(reg.data_pagamento).format("DD")
            if (reg.data_pagamento === null) {
                data_despesa = dayjs(reg.data_despesa).format("DD")
            }
            return dias_selecionados.includes(data_despesa)
        })
        handleAplicarFiltro(metricasFiltroOrdem, filtroSel, relatorios, sel, notas)
    }
    function handleRelatorioStatusSelecionado(event: any) {
        const STATUS: string = event.status
        let relatoriosAux = handleRelatoriosSelecionados(relatorios, despesasSel)
        relatoriosAux = relatoriosAux.filter(reg => reg.id_status.descricao === STATUS)
        let status_selecionados = statusSelecionados
        const EXISTE = status_selecionados.filter((reg) => reg === STATUS).length === 0 ? false : true
        if (EXISTE) {
            status_selecionados = status_selecionados.filter((reg) => reg !== STATUS)
        } else {
            status_selecionados.push(STATUS)
        }
        setStatusSelecionados(status_selecionados)
        if (status_selecionados.length === 0) {
            handleAplicarFiltro(metricasFiltroOrdem, filtroSel, relatorios, despesas, notas)
            return
        }
        let relatoriosAuxIds: number[] = []
        for (let reg of relatoriosAux) {
            relatoriosAuxIds.push(reg.id_relatorio)
        }
        let despesasSelAux: any = handleAplicarFiltro(metricasFiltroOrdem, filtroSel, relatorios, despesas, notas)
        let sel = despesasSelAux.filter((reg: any) => {
            let id_relatorio = reg.id_relatorio.id_relatorio
            return relatoriosAuxIds.includes(id_relatorio)
        })
        handleAplicarFiltro(metricasFiltroOrdem, filtroSel, relatoriosAux, sel, notas)
    }

    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={(event: any) => { setLoading(!loading) }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <DespesasMetricasDatas inicial={dataInicialTemp} final={dataFinalTemp} handleChange={handleChangeDate} handleArrow={handleArrow} />

                <div className="div-row">

                    <div>

                        <div className="div-row" style={{ marginBottom: "10px" }}>
                            <DespesasMetricasFiltroOptions options={metricasFiltro.empresas} id_form="id_empresas" label="Empresas" value={filtroEmpresas} onChange={handleChangeFiltro} />
                            <DespesasMetricasFiltroOptions options={metricasFiltro.categorias} id_form="id_categorias" label="Categorias" value={filtroCategorias} onChange={handleChangeFiltro} />
                            <DespesasMetricasFiltroOptions options={metricasFiltro.clientes} id_form="id_clientes" label="Clientes" value={filtroClientes} onChange={handleChangeFiltro} />

                        </div>
                        <div className="div-row">
                            <DespesasMetricasFiltroOptions options={metricasFiltro.usuarios} id_form="id_usuarios" label="Usuários" value={filtroUsuarios} onChange={handleChangeFiltro} />
                            <DespesasMetricasFiltroOptions options={metricasFiltro.formasPagamento} id_form="id_formasPagamento" label="Forma Pagamento" value={filtroFormasPagamento} onChange={handleChangeFiltro} />
                            <DespesasMetricasFiltroOptions options={metricasFiltro.cartoes} id_form="id_cartoes" label="Cartões" value={filtroCartoes} onChange={handleChangeFiltro} />
                        </div>
                        {/**
                        <div className="div-row">
                            <p>Filtro: {metricasFiltroOrdem.toString()}</p>
                        </div>
                        */}

                    </div>

                    <div style={{ marginLeft: "30px" }}>

                        <Button variant='primary' style={{ height: '40px' }} onClick={() => { loadDespesas() }} className="div-row"><p>Filtrar</p><span className="material-symbols-outlined">filter_alt</span></Button>

                    </div>

                </div>
            </div>
            
            <div className="div-row" style={{ width: "100%" }}>
                <div style={{ width: "50%" }}>
                    <div className='div-row'>
                        <DespesasTotais title='NFS Total Líquido' totalRegistros={`${despesasTotal.nf_valor_liquido}`} />
                        <DespesasTotais title='Total Despesas' totalRegistros={`${despesasTotal.valor}`} />
                        <DespesasTotais title='Lucro Bruto' totalRegistros={`${despesasTotal.lucro_bruto}`} />
                    </div>
                    <div className='div-row' style={{ width: "100%", alignContent: "space-between" }}>
                        <DespesasTotais title='NFS Total Emitido' totalRegistros={`${despesasTotal.nf_valor}`} />
                        <DespesasTotais title='Qtd. Despesas' totalRegistros={`${despesasTotal.qtd}`} />
                        <DespesasTotais title='Qtd. Notas' totalRegistros={`${despesasTotal.nf_qtd}`} />
                        <DespesasTotais title='Qtd. Relatórios' totalRegistros={`${despesasTotal.qtd_relatorios}`} />
                    </div>
                    <div className="div-row">
                        <DespesasTotais title='Castos Internos' totalRegistros={`${despesasTotal.valor_interno} / ${despesasTotal.valor_interno_por} %`} />
                        <DespesasTotais title='Castos Contratos' totalRegistros={`${despesasTotal.valor_contratos} / ${despesasTotal.valor_contratos_por} %`} />
                    </div>
                </div>
                <DespesasGraficoBarStatusRelatorios relatorios={relatorios} despesas={despesasSel} handleRelatorioStatusSelecionado={handleRelatorioStatusSelecionado} />
            </div>

            <MetricasGraficoBarraDias dataInicial={dataInicial} dataFinal={dataFinal} despesas={despesasSel} handleDiaSelecionado={handleDiaSelecionado} />

            {/* <br></br> */}
            <div className="div-row" style={{ alignItems: "start" }}>
                <DespesasGraficoTabela dados={despesasSel} filtro="empresas" titulo="Despesas por Empresas" tabela="Empresa" filtroDados={metricasFiltroDados} />
                <DespesasGraficoTabela dados={despesasSel} filtro="usuarios" titulo="Despesas por Usuários" tabela="Usuário" filtroDados={metricasFiltroDados} />
            </div>
            <div className="div-row" style={{ alignItems: "start" }}>
                <DespesasGraficoTabela dados={despesasSel} filtro="clientes" titulo="Despesas por Clientes" tabela="Cliente" filtroDados={metricasFiltroDados} />
                <DespesasGraficoTabela dados={despesasSel} filtro="categorias" titulo="Despesas por Categorias" tabela="Categoria" filtroDados={metricasFiltroDados} />
            </div>
            <div className="div-row" style={{ alignItems: "start" }}>
                <DespesasGraficoTabela dados={despesasSel} filtro="formas_pagamento" titulo="Despesas por Formas de Pagamento" tabela="Forma de Pagamento" filtroDados={metricasFiltroDados} />
                <DespesasGraficoTabela dados={despesasSel} filtro="cartoes" titulo="Despesas por Cartões Corporativos" tabela="Cartão Corporativo" filtroDados={metricasFiltroDados} />
            </div>
            <br></br>

            <div className="div-row">
                <DespesasTabelaPesquisa data={despesasSel} filtros={metricasFiltroDados} />
            </div>
            
        </div>
    )
}

interface iMetricasDadosResponse {
    relatorios: any[]
    despesas: any[]
    notas: any[]
}
interface iMetricasFiltro {
    empresas: any[]
    usuarios: any[]
    categorias: any[]
    clientes: any[]
    formasPagamento: any[]
    cartoes: any[]
}
interface iTotalDespesas {
    qtd: number
    qtd_relatorios: number
    valor: string
    valor_interno: string
    valor_interno_por: string
    valor_interno_qtd: number
    valor_contratos: string
    valor_contratos_por: string
    valor_contratos_qtd: number

    nf_qtd: number
    nf_valor: string
    nf_valor_liquido: string

    lucro_bruto: string
}
